module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Layout_Stateoff', {
		configure: function () {
			this.registerOptions('', {
				
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');
	
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/layout/stateoff.js
// module id = 857
// module chunks = 4